import { render, staticRenderFns } from "./order_return_product_list.vue?vue&type=template&id=905f6218&scoped=true"
import script from "./order_return_product_list.vue?vue&type=script&lang=js"
export * from "./order_return_product_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905f6218",
  null
  
)

export default component.exports